<template>
  <div class="info-box">
    <el-form
      :model="state.model"
      label-width="auto"
      label-position="top"
      ref="formDom"
      size="large"
      class="flex-1 overflow-y-auto px-2.5"
    >
      <ul class="items-center gap-x-3 grid grid-cols-2">
        <el-form-item label="状态">
          <el-switch
            v-model="state.model.status"
            active-text="启用"
            inactive-text="禁用"
            inline-prompt
            :active-value="1"
            :inactive-value="0"
          />
        </el-form-item>
        <el-form-item
          label="类型"
          prop="d_news_type_id"
          :rules="[{ required: true, message: '请选择类型', trigger: 'blur' }]"
        >
          <el-select v-model="state.model.d_news_type_id">
            <el-option
              v-for="item in state.lx_data"
              :key="item"
              :label="item.name"
              :value="item.id"
            ></el-option>
            <template #footer>
              <el-button
                plain
                class="float-right mb-3"
                size="small"
                @click="onLoadLx"
              >
                刷新
              </el-button>
            </template>
          </el-select>
        </el-form-item>
      </ul>
      <el-form-item
        label="标题"
        prop="title"
        :rules="[{ required: true, message: '请输入名称', trigger: 'blur' }]"
      >
        <el-input v-model="state.model.title"></el-input>
      </el-form-item>
      <el-form-item label="摘要">
        <el-input v-model="state.model.description" type="textarea"></el-input>
      </el-form-item>
      <el-form-item label="内容">
        <c_editor
          @change="
            (value) => {
              state.model.content = value;
            }
          "
          :value="state.model.content"
        ></c_editor>
      </el-form-item>
      <el-form-item label="是否置顶">
        <el-checkbox
          v-model="state.model.is_top"
          :true-value="1"
          :false-value="0"
        />
      </el-form-item>
    </el-form>
    <div class="submit-box px-2.5">
      <el-button type="primary" size="large" @click="onSubmit">
        提交
      </el-button>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { dic_getNewsType } from "@/http/data";
import {
  meeting_website_news_detail,
  meeting_website_news_add,
  meeting_website_news_edit,
} from "@/http/meeting";
import { post_response } from "@/utils/funcs";

export default {
  props: {
    id: Number,
    meeting_id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {
        status: 1,
        meeting_id: props.meeting_id,
      },
    });
    onMounted(() => {
      onLoadLx();
      if (props.id) {
        meeting_website_news_detail(props.id).then((res) => {
          if (res.status == 200) {
            state.model = res.data?.data;
          }
        });
      }
    });

    //获取部门
    const onLoadLx = () => {
      dic_getNewsType().then((res) => {
        if (res.status == 200) state.lx_data = res.data?.data || [];
      });
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          if (props.id) {
            meeting_website_news_edit(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          } else {
            meeting_website_news_add(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          }
        }
      });
    };

    return {
      state,
      props,
      formDom,
      onSubmit,
      onLoadLx,
    };
  },
};
</script>
<style scoped></style>
